import { render, staticRenderFns } from "./InsuredHistory.vue?vue&type=template&id=78913cc8&"
import script from "./InsuredHistory.vue?vue&type=script&lang=js&"
export * from "./InsuredHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports